<template>
  <div id="orderOnDemand">
    <div class="Info">
      <h1>Order On-Demand</h1>
      <form action="">
        <div class="buttonsSection"></div>
        <table>
          <tr>
            <td>
              <input type="text" name="" placeholder="Name" />
            </td>
          </tr>
          <tr>
            <td>
              <input type="text" name="" placeholder="Phone Number" />
            </td>
          </tr>

          <tr>
            <td>
              <input type="text" name="" placeholder="Address" />
            </td>
          </tr>
        </table>
        <div class="d-flex flex-wrap mt-6">
          <div class="text-center mr-6">
            <!-- <v-btn rounded color="primary" height="60"> Number </v-btn> -->
            <div class="Liters">
              <p>Number of Litres</p>
              <div class="counter">
                <div class="InnerCounter">
                  <button type="button" v-on:click="decreaseLiters">
                    <img src="../assets/icons/minus-button.png" />
                  </button>
                  <h1>{{ counterLiters }} Liters</h1>
                  <button type="button" v-on:click="increaseLiters">
                    <img src="../assets/icons/plus-button.png" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center">
            <p>When do you want us to deliver?</p>
            <v-btn
              class="text-center mt-0"
              @click="showCalendar"
              height="60"
              rounded
              color="primary"
            >
              Pick Date
            </v-btn>
          </div>
        </div>
        <!-- <ButtonDetails id="calendar" :StartDate="DatePicker" /> -->
        <div id="calendar">
          <v-row id="whenToStart" @click="getDate()">
            <v-date-picker v-model="OderOnDemandpicker"></v-date-picker>
          </v-row>
        </div>
        <div class="formPrice">
          <p>Total:</p>
          <h1>{{ this.DemandResults() }}</h1>
        </div>
        <div class="buttonsSection">
          <button class="subscribe">Place Order</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
// import ButtonDetails from "./ButtonDetails";
export default {
  components: {
    // ButtonDetails,
  },
  data() {
    return {
      counterLiters: 2,
      // DemandSum: this.DemandTotal(),
      picker: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      OderOnDemandpicker: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
    };
  },
  methods: {
    getDate() {
      console.log(this.OderOnDemandpicker);
    },
    DemandResults() {
      var total = 1000 * this.counterLiters;
      // console.log(this.counterLiters)
      return total;
    },
    showCalendar() {
      var calendar = document.getElementById("calendar");
      calendar.style.display = "unset";
    },
    decreaseLiters() {
      if (this.counterLiters > 0) {
        this.counterLiters--;
      }
    },
    increaseLiters() {
      this.counterLiters++;
    },
  },
};
</script>

<style scoped>
#orderOnDemand {
  width: 90%;
  margin: auto;
  padding-top: 100px;
}
#calendar {
  color: #fff;
  display: none;
}
h1 {
  margin-bottom: 50px;
  color: #343540;
  font-family: "DM Sans";
  font-size: 36px;
  font-weight: 700;
  line-height: 47px;
  text-align: left;
}
form input {
  padding: 10px;
  margin-top: 20px;
  box-sizing: border-box;
  height: 40px;
  width: 438px;
  border-radius: 30px;
  border: 1px solid #343540;
}
form {
  position: relative;
}
table {
  width: 100%;
}
.formPrice {
  position: absolute;
  bottom: 30px;
  right: 30px;
}
.formPrice h1 {
  margin: unset;
  color: #343540;
  font-size: 26px;
  font-weight: 500;
}
.buttonsSection {
  display: grid;
  place-items: center;
}
.counter {
  display: grid;
  /* place-items: center; */
  height: 50px;
}
.InnerCounter {
  text-align: center;
  display: flex;
  color: #343540;
}
.InnerCounter button {
  margin-top: 8px;
  width: 40px;
  background: none;
  height: 40px;
}
.InnerCounter h1 {
  padding-top: 0px;
  margin: 0px 10px 0px 10px;
  color: #343540;
}
button {
  box-sizing: border-box;
  border-radius: 60px;
  height: 60px;
  width: 220px;
  border: unset;
  font-size: 20px;
  font-weight: 500;
  color: #fff;
  background-color: #0077b6;
  margin: 30px auto 30px auto;
}
@media screen and (max-width: 720px) {
  form input {
    width: 100%;
  }
  .formPrice {
    position: unset;
    text-align: center;
  }
  .formPrice h1 {
    text-align: center;
  }
}
</style>